import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

import { ref, reactive, getCurrentInstance } from 'vue'
import { getPackageListApi, getSupplierListApi, saveInApi } from '../../../apis/coupon-saas'
import { CouponType } from '../enum'
import Keys from '@/constant/key'

interface ItemI { // 券包列表、供应商列表格式
    id: string,
    name: string
}

// 可选券包列表：仅采购类型支持采购入库
interface FormI {
    coupon_id: string, // 券包ID
    supplier_id: string, // 供应商ID
    clearing_price: string, // 结算价
    invoice_type: number | string, // 发票类型
    tax_point: string, // 税点
    file: any, // 上传文件
    note: string, // 备注
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InDialog',
  emits: ['reloadList'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit

const { proxy } = getCurrentInstance() as any

const packageList = ref<ItemI[]>([])
const getPackageList = async () => {
    const { code, data, msg } = await getPackageListApi({ type: CouponType['采购'], select: true }) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    packageList.value = data
}

// 可选供应商列表
const supplierList = ref<ItemI[]>([])
const getSupplierList = async () => {
    const { code, data, msg } = await getSupplierListApi({ select: true }) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    supplierList.value = data
}

// 可选发票类型列表
const invoiceTypeList = ref<string[]>(["未设置", "专票(纸质版)", "专票(电子版)", "普票(纸质版)", "普票(电子版)", "无票", "其他"])
// const getInvoiceTypeList = async () => {
//     const { code, data, msg } = await getInvoiceTypeListApi() as any
//     if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
//     invoiceTypeList.value = data
// }
// getInvoiceTypeList()

// 券包弹框数据
const formData = ref<FormI>({ // 券包弹框表单
    coupon_id: '', // 券包ID
    supplier_id: '', // 供应商ID
    clearing_price: '', // 结算价
    invoice_type: '', // 发票类型
    tax_point: '', // 税点
    file: '', // 上传文件
    note: '', // 备注
})

// 上传成功后跳转到批量上传列表
const addFile = (params) => {
    formData.value.file = params.file
    clearValidate('file')
}

const uploadRef = ref()
// 超出数量限制执行的回调：替换文件
const onExceed = (files) => {
    uploadRef.value!.clearFiles()
    const file = files[0]
    uploadRef.value!.handleStart(file)
    formData.value.file = file
}
// 移除文件监听
const onRemove = () => {
    formData.value.file = ''
}
// 清除指定校验规则
const clearValidate = (ruleName:string) => {
    proxy.$refs['inForm'].clearValidate([ruleName])
}

// 保存采购
const saveIn = () => {
    proxy.$refs['inForm'].validate((valid:boolean) => {
        if (valid) {
            saveInApi(formData.value).then((res:any) => {
                const { code, data, msg } = res
                if (code != 200) {
                    formData.value.file = ''
                    uploadRef.value!.clearFiles()
                    return proxy.$message({ type: 'error', message: msg })
                }
                proxy.$message({ type: 'success', message: '保存成功' })
                onDialogClose()
                emit('reloadList')
            })
        }
    })
}
// 关闭弹框，清空数据
const onDialogClose = () => {
    dialogShow.value = false
    proxy.$refs['inForm'].resetFields()
    uploadRef.value!.clearFiles()
}

const rules = reactive({
    coupon_id: [
        { required: true, message: '请选择券包', trigger: 'change' }
    ],
    supplier_id: [
        { required: true, message: '请选择供应商', trigger: 'change' }
    ],
    clearing_price: [
        { required: true, message: '请输入结算价', trigger: 'change' }
    ],
    invoice_type: [
        { required: true, message: '请选择发票类型', trigger: 'change' }
    ],
    tax_point: [
        { required: true, message: '请输入税点', trigger: 'change' }
    ],
    file: [
        { required: true, message: '请选择上传文件', trigger: 'change' }
    ],
})

// 表单数据
const dialogShow = ref<boolean>(false) // 弹框状态
// 打开弹框
const openDialog = () => {
    getPackageList() // 获取采购类券包列表
    getSupplierList() // 获取供应商列表
    dialogShow.value = true
}

// 暴露方法
__expose({
    openDialog, // 打开弹框
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "采购入库",
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogShow).value = $event)),
    "before-close": onDialogClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: onDialogClose }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("取消")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: saveIn
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode("确定")
        ])),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: formData.value,
        ref: "inForm",
        "label-width": "100",
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "券包",
            prop: "coupon_id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.coupon_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.coupon_id) = $event)),
                placeholder: "请选择券包",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "供应商",
            prop: "supplier_id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.supplier_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.supplier_id) = $event)),
                placeholder: "请选择供应商",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "结算价",
            prop: "clearing_price"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.clearing_price,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.clearing_price) = $event)),
                autocomplete: "off",
                placeholder: "请输入结算价",
                onInput: _cache[3] || (_cache[3] = ($event: any) => (formData.value.clearing_price=formData.value.clearing_price.replace(/[^0-9.]/g,'')))
              }, {
                append: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("元")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "发票类型",
            prop: "invoice_type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.invoice_type,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.invoice_type) = $event)),
                placeholder: "请选择发票类型"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoiceTypeList.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item,
                      value: index
                    }, null, 8, ["label", "value"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "税点",
            prop: "tax_point"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.tax_point,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.tax_point) = $event)),
                autocomplete: "off",
                placeholder: "请输入结算价",
                onInput: _cache[6] || (_cache[6] = ($event: any) => (formData.value.tax_point=formData.value.tax_point.replace(/[^0-9]/g,'')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "上传文件",
            prop: "file"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                ref_key: "uploadRef",
                ref: uploadRef,
                action: "#",
                accept: ".xls,.xlsx",
                limit: 1,
                "on-exceed": onExceed,
                "http-request": addFile,
                "on-remove": onRemove
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("点击上传")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "note"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.note,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.note) = $event)),
                modelModifiers: { trim: true },
                type: "textarea",
                placeholder: "请输入备注",
                maxlength: "100",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_link, {
                href: `${_unref(Keys).baseUrl}/coupon/offline_coupon/getCouponItemMb?type=primary`
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("下载采购入库模版")
                ])),
                _: 1
              }, 8, ["href"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})